import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsAddressCompleteGuard } from '@gk/gk-modules';
import { CompositeGuard } from '../../guards/composite/composite.guard';
import { RequestInProgressGuard } from '../../guards/request-in-progress/request-in-progress.guard';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRoutes } from './../../guards/guard.models';
import { MainRequestsListComponent } from './../../shared/main-requests-list/main-requests-list.component';
import { MonumentInstallationRequestComponent } from './monument-installation-request.component';
import { MIRNewRequestComponent } from './new-request/new-request.component';

const monumentInstallationRequestRoutingRequestRoutes: Routes = [
  {
    path: MainRoutes.MonumentInstallationRequest,
    component: MonumentInstallationRequestComponent,
    canActivate: [CompositeGuard],
    data: {
      guards: [SessionGuard, IsAddressCompleteGuard],
    },
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: MIRNewRequestComponent,
        canDeactivate: [RequestInProgressGuard],
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(monumentInstallationRequestRoutingRequestRoutes),
  ],
  providers: [CompositeGuard, SessionGuard, IsAddressCompleteGuard],
  exports: [RouterModule],
})
export class MonumentInstallationRequestRoutingModule {}
